module.exports = __webpack_public_path__ + "img/strength.3c3b770d.jpg";